/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_LinkInputs */

const en_cap_money_link = /** @type {(inputs: Cap_Money_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the lead radar case study`)
};

const lv_cap_money_link = /** @type {(inputs: Cap_Money_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt par potenciālo klientu radaru`)
};

/**
* | output |
* | --- |
* | "Read the lead radar case study" |
*
* @param {Cap_Money_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_link = /** @type {((inputs?: Cap_Money_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_link(inputs)
	return en_cap_money_link(inputs)
});